import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2aaea3",
      stroke: "#2aaea3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m9 1.5 2.318 4.695 5.182.757-3.75 3.653.885 5.16L9 13.328l-4.635 2.437.885-5.16L1.5 6.952l5.183-.757z"
    }, null, -1)
  ]))]))
}
export default { render: render }